import { get, readable, writable } from 'svelte/store';

import type {
    ClientSettingsType,
    LastMileConfigResponseType,
    CustomerSettingsType,
} from '../lib/components/Settings/settings';
import {
    clientSettingsDefault,
    customerSettingsDefault,
} from '../lib/components/Settings/settings';
import { SettingsApi } from '../lib/components/Settings/SettingsApi';
import { fm } from '../lib/shared/Features/features';
import { Api } from '@automapa/svelte-automapa-template';

export const api = readable<Api>(new Api());
get(api).setDebug(false);
get(api).useFeaturesManager(get(fm));

// export const apiDev = readable<Api>( (new Api()).setApiUrl('http://localhost:3000/api') );
export const customerSettings = writable<CustomerSettingsType>(customerSettingsDefault);
export const clientSettings = writable<ClientSettingsType>(clientSettingsDefault);
export const jobs_filter_config = writable<LastMileConfigResponseType | null>(null);
export const connections_filter_config = writable<LastMileConfigResponseType | null>(null);
export const assignment_job_filter_config = writable<LastMileConfigResponseType | null>(null);
export const tactical_plan_rules_filter_config = writable<LastMileConfigResponseType | null>(null);

// export async function reloadSettings() {
//     return SettingsApi.getCustomerSettings(get(api));
// }
//
